import { schema } from 'normalizr'

const image = new schema.Entity('image')

const proposedUser = new schema.Entity(
    'proposedUser',
    { image },
    { processStrategy: entity =>
        Object.assign({}, entity, { image: entity.image ? entity.image.data : null }) }
)

const user = new schema.Entity(
    'user',
    { image },
    { processStrategy: entity =>
        Object.assign({}, entity, {
            image: entity.image ? entity.image.data : null,
            avatar: entity.image ? entity.image.data.path : null,
        }) }
)

const membershipRequest = new schema.Entity(
    'membershipRequests',
    { user },
    { processStrategy: entity =>
        Object.assign({}, entity, { user: entity.user ? entity.user.data : null }) }
)

const member = new schema.Entity(
    'members',
    {
        user,
        proposedUser,
    },
    { processStrategy: entity =>
        Object.assign({}, entity, {
            user: entity.user ? entity.user.data : null,
            proposedUser: entity.proposedUser ? entity.proposedUser.data : null,
        }) }
)

export default new schema.Entity(
    'groups',
    {
        admin: user,
        members: [member],
        managers: [user],
        membershipRequests: [membershipRequest],
    },
    {
        idAttribute: 'slug',
        processStrategy: entity =>
            Object.assign({}, entity, {
                admin: entity.admin ? entity.admin.data : null,
                managers: entity.managers ? entity.managers.data : [],
                members: entity.members ? entity.members.data.sort((a, b) => a.surname.localeCompare(b.surname)) : [],
                membershipRequests: entity.membershipRequests ? entity.membershipRequests.data : [],
            }),
    }
)
